import {
  AfterViewInit,
  Component,
  ElementRef,
  Inject,
  OnInit,
  PLATFORM_ID,
  ViewChild,
  ChangeDetectionStrategy,
} from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { GooglesheetService } from 'src/app/services/googlesheet.service';
import { MensajeWhatsappService } from 'src/app/services/mensaje-whatsapp.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class FooterComponent implements OnInit, AfterViewInit {
  data: any[] = [];
  horarios: string = '';
  anioActual: number = new Date().getFullYear();

  // Datos fijos de contacto (no vienen de la planilla): mismo IG/WhatsApp que
  // ya usa el resto del sitio, mostrados como texto al lado del ícono.
  readonly instagramHandle = '@soyiphone.olavarria';
  readonly instagramUrl = 'https://www.instagram.com/soyiphone.olavarria/';
  readonly whatsappNumero = '2284 269400';
  readonly urlMaps = 'https://maps.app.goo.gl/8izmQtVkVgXHQkmY6';

  // Embed de Google Maps sin API key (funciona con solo la dirección como
  // query) — separado del texto de Dirección, que es el que se ve.
  readonly mapsEmbedUrlSafe: SafeResourceUrl;

  // El iframe de Maps solo trae JS visual (pointer-events:none, el click lo
  // maneja el <a> que lo envuelve) pero de arranque baja ~400 KiB de scripts
  // de maps.googleapis.com — se monta recién cuando el footer entra en
  // pantalla, así no pesa en la carga inicial de ninguna ruta.
  mapaVisible = false;
  @ViewChild('mapaCol') private mapaColRef?: ElementRef<HTMLElement>;

  constructor(
    private sheetService: GooglesheetService,
    private mensajeWhatsappService: MensajeWhatsappService,
    private sanitizer: DomSanitizer,
    @Inject(PLATFORM_ID) private platformId: Object,
  ) {
    const mapsEmbedUrl =
      'https://www.google.com/maps?q=' +
      encodeURIComponent('San Lorenzo 2586, Olavarría, Buenos Aires') +
      '&output=embed';
    this.mapsEmbedUrlSafe =
      this.sanitizer.bypassSecurityTrustResourceUrl(mapsEmbedUrl);
  }

  ngOnInit(): void {
    this.getData('Footer', '!B1:B5');
  }

  ngAfterViewInit(): void {
    if (!isPlatformBrowser(this.platformId) || !this.mapaColRef) return;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          this.mapaVisible = true;
          observer.disconnect();
        }
      },
      { rootMargin: '200px' },
    );
    observer.observe(this.mapaColRef.nativeElement);
  }

  // Mismas líneas que Redes/Dirección (una .footer-line por renglón) — la
  // planilla trae "Atención...<br>Coordinamos..." como viene de las demás
  // celdas de Footer.
  get horariosLineas(): string {
    return (this.horarios || '')
      .split(/<br\s*\/?>/i)
      .map((l) => l.trim())
      .filter((l) => l)
      .map((l) => `<div class="footer-line">${l}</div>`)
      .join('');
  }

  getData(seccion: string, rangos: string) {
    this.sheetService.getSheetData(seccion + rangos, 'config').subscribe({
      next: (data) => {
        this.data = data.values;
      },
      error: (error) => {
        console.log(error);
      },
      complete: () => {
        // cada fila de Sheets llega como array (una celda por columna pedida);
        // hay que desenvolverla, si no ("fila" || '').split(...) rompe.
        this.horarios = this.data[4]?.[0] || '';
      },
    });
  }

  mensajeWhatsapp() {
    this.mensajeWhatsappService.enviarWhatsApp();
  }
}
